import * as AUDITS_API from '@/api/audits'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    loadAuditsByTags ({ commit }, tags) {
      return AUDITS_API.getAuditsByTags(tags).then((resp) => {
        return resp
      })
    }
  }
}
